import axios from 'axios'
import { push } from 'react-router-redux'
import { call, fork, put, select, take } from 'redux-saga/effects'

import { ACCESS_TOKEN, CLIENT, UID } from '../../commons/Const'
import { PaymentEventDateType } from '../../commons/PaymentFormStatus'
import { Referer } from '../../commons/Referer'
import { getParams, setStorage } from '../../commons/utils'
import * as action from '../actions/authActions'
import { CustomPcStore } from '../store'

const authStore = (state: CustomPcStore) => state.auth

export function* runPostLoginHandler() {
  while (true) {
    const { payload } = yield take([`${action.POST_LOGIN}`])
    yield fork(postLoginHandler, payload)
  }
}
function* postLoginHandler(payload: any) {
  const { data, error } = yield call(postLogin, payload)
  if (error != null) {
    yield put(action.POST_LOGIN_FAILURE(error))
    return
  }
  saveAuthResponse(data.data)
  if (getParams().redirect) {
    const redirectPath = decodeURIComponent(getParams().redirect)
    yield put(push(redirectPath))
  } else {
    yield put(push('/'))
  }

  yield put(action.POST_LOGIN_SUCCESS(data))
}
const postLogin = async (data: any) => {
  // deviseの標準エラーのため形式が他と異なる
  return await axios
    .post('/api/v1/organizers/auth/sign_in', data)
    .catch(error => ({ error: error.response.data.errors[0] }))
}
export function* runPostSignupHandler() {
  while (true) {
    yield take([`${action.POST_SIGNUP}`])
    const auth = yield select(authStore)
    yield fork(postSignupHandler, auth)
  }
}
function* postSignupHandler(payload: action.AuthState) {
  const { data, error } = yield call(postSignup, payload)
  if (error != null) {
    yield put(action.POST_SIGNUP_FAILURE(error))
    return
  }
  saveAuthResponse(data.data)
  yield put(action.POST_SIGNUP_SUCCESS(data))
}
const postSignup = async ({ signupEmail, signupPassword }: action.AuthState) => {
  return await axios
    .post('/api/v1/organizers/auth', {
      email: signupEmail,
      password: signupPassword,
      password_confirmation: signupPassword
    })
    .catch(error => ({ error: error.response.data }))
}

export function* runPostPaymentHandler() {
  while (true) {
    yield take([`${action.POST_PAYMENT}`])
    const auth = yield select(authStore)
    yield fork(postPaymentHandler, auth)
  }
}
function* postPaymentHandler(payload: action.AuthState) {
  const { error } = yield call(postPayment, payload)
  if (error != null) {
    yield put(action.POST_PAYMENT_FAILURE(error))
    return
  }
  yield put(action.POST_PAYMENT_SUCCESS(payload.paymentPlan))
}
const postPayment = async ({
  stripeToken,
  paymentFirstName,
  paymentFamilyName,
  paymentPlan,
  paymentSelectedDateOption,
  paymentEventDate,
  paymentSelectedRefererOption,
  paymentOtherReferer
}: action.AuthState) => {
  const dateInfo = paymentSelectedDateOption === PaymentEventDateType.UNKNOWN ? null : paymentEventDate
  const refererInfo = Referer.info(Number(paymentSelectedRefererOption))
  return await axios
    .post('/api/v1/organizers/projects/payment', {
      token: stripeToken,
      first_name: paymentFirstName,
      family_name: paymentFamilyName,
      plan: paymentPlan,
      event_date: dateInfo,
      referer: refererInfo.name === 'その他' ? paymentOtherReferer : refererInfo.name
    })
    .catch(error => ({ error: error.response.data }))
}

const saveAuthResponse = (data: any) => {
  setStorage(UID, data.uid)
  setStorage(CLIENT, data.client)
  setStorage(ACCESS_TOKEN, data['access-token'])
}

export function* runResetPasswordHandler() {
  while (true) {
    const { payload: token } = yield take([`${action.POST_RESET_PASSWORD}`])
    const auth = yield select(authStore)
    yield fork(postResetPasswordHandler, {
      token,
      newPassword: auth.newPassword
    })
  }
}
function* postResetPasswordHandler(payload: { newPassword: string; token: string }) {
  const { data, error } = yield call(postResetPassword, payload)
  if (error != null) {
    yield put(action.POST_RESET_PASSWORD_FAILURE(error))
    return
  }
  yield put(action.POST_RESET_PASSWORD_SUCCESS(data))
}
const postResetPassword = async ({ newPassword, token }: { newPassword: string; token: string }) => {
  return await axios
    .post('/api/v1/organizers/password/reset', {
      token,
      password: newPassword
    })
    .catch(error => ({ error: error.response.data }))
}

// 退会
export function* runWithdrawHandler() {
  while (true) {
    yield take([`${action.WITHDRAW}`])
    yield fork(postWithdrawHandler)
  }
}
function* postWithdrawHandler() {
  const { data, error } = yield call(postWithdraw)
  if (error != null) {
    yield put(action.WITHDRAW_FAILURE(error))
    return
  }
  yield put(action.WITHDRAW_SUCCESS(data))
}
const postWithdraw = async () => {
  return await axios.delete('/api/v1/organizers/withdraw').catch(error => ({ error: error.response.data }))
}
